import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp8} ${props => props.theme.spacing.sp16};
  cursor: pointer;
  border-radius: ${props => props.theme.primitives.radius.radius2};

  ${props =>
    props.active &&
    css`
      background-color: ${props => props.theme.colors.disabled.surface};
    `}

  &:hover {
    background-color: ${props => props.theme.colors.disabled.surface};
  }
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.theme.size.M};
  height: ${props => props.theme.size.M};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  background-color: ${props => props.theme.colors.background.secondary};
  flex-shrink: 0;
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
`

export const Title = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.colors.accent.on};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Subtitle = styled.span`
  font-size: 12px;
  color: ${props => props.theme.colors.text.subtle};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StatusBadge = styled.span`
  font-size: 11px;
  color: ${props => props.theme.colors.text.subtle};
  background-color: ${props => props.theme.colors.disabled.surface};
  padding: ${props => props.theme.spacing.sp2} ${props => props.theme.spacing.sp8};
  border-radius: ${props => props.theme.primitives.radius.radius1};
  white-space: nowrap;
  flex-shrink: 0;
`
